import { INTERACTIONS } from '../constants/Constants';
import { ToyboxRays } from './ToyboxRays';

const VO_MAP = {
  reveal: ['NFC_6.0_95'],
  return: ['NFC_6.0_99', 'NFC_6.0_100'],
  completed: ['NFC_6.0_105'],
  bounce: ['NFC_6.0_101'],
  playful_stretching: 'NFC_7.0_117',
  humalong: 'NFC_7.0_115',
  star_breathing: 'NFC_7.0_113',
};

export class ToyboxUnlock extends Phaser.GameObjects.Container {
  constructor(scene, x, y, unlockItem) {
    super(scene, x, y);

    scene.add.existing(this);

    const front = scene.add.image(0, 0, 'toybox', 'toybox_front').setOrigin(0.5, 1);
    const back = scene.add.image(front.x, front.y - 30, 'toybox', 'toybox_back').setOrigin(0.5, 1);

    this.particles = this.scene.add.particles(x, y, 'toybox', {
      lifespan: { min: 1000, max: 2000 },
      scale: { start: 1, end: 0 },
      frequency: 100,
      speedX: { min: -20, max: 20 },
      speedY: { min: -20, max: 20 },
      emitZone: {
        type: 'random',
        source: new Phaser.Geom.Circle(0, 0, 150),
      },
      active: false,
      frame: [
        'toyboox_star_1',
        'toyboox_star_2',
        'toyboox_star_3',
        'toyboox_star_4',
        'toyboox_star_5',
        'toyboox_star_6',
      ],
    });

    this._unlockId = unlockItem;
    this.toyboxItems = INTERACTIONS.map((interaction, i) => {
      const x = -90 + 95 * i;
      const y = front.y - front.height * 0.9;
      const unlocked =
        interaction.id != unlockItem && this.scene.game.player.hasToyBoxItem(interaction.id);
      const item = scene.add.image(
        x,
        y,
        'toybox',
        `toybox_item_${interaction.id}${unlocked ? '' : '_grey'}`
      );
      item.defaultPosition = { x, y };
      item.id = interaction.id;
      return item;
    });

    this.add([back, this.particles, ...this.toyboxItems, front]);
  }

  unlockItem() {
    this.emit('open');
    this.toyboxItems.forEach((item, i) => {
      const angle = Phaser.Math.DegToRad(-120 + 30 * i);
      const dx = 450 * Math.cos(angle);
      const dy = 450 * Math.sin(angle);
      this.scene.tweens.add({
        targets: item,
        x: dx,
        y: dy,
        duration: 500,
        ease: Phaser.Math.Easing.Back.Out,
        onComplete: i > 0 ? false : () => this._revealUnlock(this._unlockId),
      });
    });
  }

  _revealUnlock(id) {
    const unlockItem = this.toyboxItems.find((i) => i.id === id);
    unlockItem.setFrame(`toybox_item_${id}_open`);
    unlockItem.revealed = true;
    this.addStarBurst(unlockItem.x, unlockItem.y);
    this.scene.game.vo.playChain(VO_MAP.reveal);
    this.scene.game.soundController.playSFX('sfx', 'new-toy');
    this.scene.tweens.add({
      targets: unlockItem,
      scale: 1.5,
      repeat: 1,
      yoyo: true,
      duration: 250,
      onComplete: () => this._returnItems(),
    });
  }

  _returnItems() {
    this.emit('close');
    this.particles.frequency = -1;
    this.toyboxItems.forEach((item, i) => {
      if (item.revealed) item.setFrame(`toybox_item_${item.id}`);
      this.scene.tweens.add({
        targets: item,
        x: item.defaultPosition.x,
        y: item.defaultPosition.y,
        duration: 500,
        delay: 500,
        ease: Phaser.Math.Easing.Back.Out,
        completeDelay: 200,
      });
    });

    this.scene.game.vo.playChain([...VO_MAP.return, VO_MAP[this._unlockId]], {
      onComplete: this._bounceBox,
      onCompleteScope: this,
    });
  }

  _bounceBox() {
    const vo = [...VO_MAP.bounce];
    if (this.scene.game.player.getToyboxItems().length == 3) vo.push(VO_MAP.completed);
    this.scene.game.vo.playChain(vo, { onComplete: () => this.emit('complete') });
    this.scene.tweens.add({
      targets: this,
      scale: 1.1,
      yoyo: true,
      repeat: 1,
      duration: 150,
    });
  }

  addStarBurst(x, y) {
    this.particles.setPosition(x, y);
    this.particles.active = true;
  }

  addItem(id) {
    const item = this.scene.add.image(0, -450, 'toybox', `toybox_item_${id}`).setScale(0);
    const stars = this.scene.add.image(0, -350, 'toybox', 'toybox_sparkles').setScale(0);
    this.addAt(item, 1);
    this.add(stars);

    this.scene.tweens.chain({
      tweens: [
        {
          targets: item,
          scale: { from: 0, to: 1 },
          y: { from: -250, to: -450 },
          ease: Phaser.Math.Easing.Back.Out,
          duration: 250,
        },
        {
          targets: item,
          y: -250,
          ease: Phaser.Math.Easing.Back.Out,
          duration: 150,
          delay: 1000,
        },
      ],
    });

    this.scene.tweens.chain({
      tweens: [
        {
          targets: stars,
          scale: { from: 0, to: 1 },
          duration: 100,
        },
        {
          targets: stars,
          alpha: 0,
          duration: 500,
          delay: 500,
          onComplete: () => stars.destroy(),
        },
      ],
    });
  }
}
